import type { RedirectLoginOptions } from "@auth0/auth0-react";
import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import { routeTree } from "./routeTree.gen";

export type AuthContext = {
  isAuthenticated: boolean;
  getAccessTokenSilently: () => Promise<string>;
  loginWithRedirect: (opts?: RedirectLoginOptions) => Promise<void>;
};

export type RouterContext = {
  queryClient: QueryClient;
  auth: AuthContext;
};

export function createAppRouter(queryClient: QueryClient, auth: AuthContext) {
  return createRouter({
    routeTree,
    context: { queryClient, auth },
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }

  interface StaticDataRouteOption {
    title?: string;
    breadcrumb?: string;
    breadcrumbIcon?: LucideIcon;
    breadcrumbLink?: boolean;
  }
}
